import React from 'react'
import './AfficherPartiePerdu.scss'

export default function AfficherPartiePerdu({score, reinitialiserJeu}) {
    return (
        <div className="modal">
            <div className="popup">
                <p className='msg_perdu'>Désolé tu as perdu</p>
                <p className='msg_score'>Ton score : {score}</p>
                <button className="btn_rejouer" onClick={reinitialiserJeu}>REJOUER</button>
            </div>
        </div>
    )
}
